import { render, staticRenderFns } from "./EditProducts.vue?vue&type=template&id=d8435d52&"
import script from "./EditProducts.vue?vue&type=script&lang=ts&"
export * from "./EditProducts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports